const EVENT_NAMES = new Set([
  'book_tour_cta_click',
  'lead_form_start',
  'lead_form_submit_attempt',
  'lead_form_submit_success',
  'lead_form_submit_failure',
  'location_interaction',
  'phone_click',
  'email_click',
]);

const PROPERTY_NAMES = new Set([
  'page_path',
  'cta_placement',
  'location_context',
  'component_context',
  'destination',
  'form_id',
  'form_source',
  'selected_interests',
]);

const LOCATION_CONTEXTS = new Set([
  'brentwood',
  'discovery_bay',
  'both',
  'unspecified',
]);

function sanitizeProperties(properties) {
  return Object.entries(properties).reduce((safe, [key, value]) => {
    if (!PROPERTY_NAMES.has(key)) return safe;

    if (key === 'location_context') {
      safe[key] = LOCATION_CONTEXTS.has(value) ? value : 'unspecified';
      return safe;
    }

    if (key === 'selected_interests') {
      if (Array.isArray(value)) {
        safe[key] = value
          .filter((interest) => typeof interest === 'string')
          .slice(0, 20)
          .map((interest) => interest.slice(0, 80));
      }
      return safe;
    }

    if (typeof value === 'string') {
      safe[key] = value.slice(0, 160);
    }

    return safe;
  }, {});
}

/**
 * Local semantic hook for the approved analytics contract.
 *
 * This function deliberately performs no network request and does not write to
 * dataLayer, storage, or an analytics SDK. A consent-aware production adapter
 * may subscribe to the event in a separately approved workstream.
 */
export function emitSemanticEvent(eventName, properties = {}) {
  if (!EVENT_NAMES.has(eventName) || typeof window === 'undefined') return false;

  window.dispatchEvent(new CustomEvent('dv:semantic-event', {
    detail: {
      event: eventName,
      properties: sanitizeProperties(properties),
    },
  }));

  return true;
}

